import { render, staticRenderFns } from "./template.pug?vue&type=template&id=0907c4e3&scoped=true&lang=pug&"
import script from "./script.ts?vue&type=script&lang=js&"
export * from "./script.ts?vue&type=script&lang=js&"
import style0 from "./style.sass?vue&type=style&index=0&id=0907c4e3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0907c4e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
